module.exports = __webpack_public_path__ + "static/media/CTLA_10-216w.42453f1b.webp";